import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b582f1aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_user_clone",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "newTargetCloneModalRef",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-100 mw-lg-50" }
const _hoisted_3 = { class: "modal-content mx-md-15" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy fs-3 text-primary" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-5 px-lg-7 mh-700px scroll-y bg-light" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-top table-row-bordered mb-0 fs-6 min-w-300px" }
const _hoisted_11 = { class: "fw-bold text-gray-600" }
const _hoisted_12 = {
  class: "text-muted ps-5 w-50",
  colspan: "1"
}
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_18 = { class: "d-block" }
const _hoisted_19 = { class: "required" }
const _hoisted_20 = { class: "fv-plugins-message-container text-start" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_23 = { class: "d-block" }
const _hoisted_24 = { class: "required" }
const _hoisted_25 = { class: "fv-plugins-message-container text-start" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_28 = { class: "d-block" }
const _hoisted_29 = { class: "required" }
const _hoisted_30 = { class: "fv-plugins-message-container text-start" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_33 = { class: "d-block" }
const _hoisted_34 = { class: "required" }
const _hoisted_35 = { class: "fv-plugins-message-container text-start" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_38 = { class: "d-block" }
const _hoisted_39 = { class: "required" }
const _hoisted_40 = { class: "fv-plugins-message-container text-start" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_43 = { class: "d-block" }
const _hoisted_44 = { class: "required" }
const _hoisted_45 = { class: "fv-plugins-message-container text-start" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_48 = { class: "d-block" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "fv-plugins-message-container text-start" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = {
  class: "text-muted ps-5 min-w-125px align-top",
  colspan: "2"
}
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = { class: "" }
const _hoisted_55 = { class: "fv-row" }
const _hoisted_56 = { id: "kt_docs_repeater_basic" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = { "data-repeater-item": "" }
const _hoisted_59 = { class: "form-group row" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "input-group d-flex align-items-center mb-3" }
const _hoisted_62 = { class: "input-group-text w-40px justify-content-center" }
const _hoisted_63 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_64 = { class: "input-group-text cursor-pointer w-40px justify-content-center" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-danger fs-6" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-circle text-primary m-1 fs-6" }, null, -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Add another number ")
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_77 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_78 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_79 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}
const _hoisted_80 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_1",
  "aria-expanded": "true",
  "aria-controls": "kt_accordion_1_body_1"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3 fs-4 text-primary" })
  ])
], -1))
const _hoisted_82 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_83 = { class: "fv-help-block p-5" }
const _hoisted_84 = { role: "alert" }
const _hoisted_85 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse accor-body",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_86 = { class: "accordion-body" }
const _hoisted_87 = { class: "table-responsive" }
const _hoisted_88 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_89 = { class: "fw-bold text-muted" }
const _hoisted_90 = { class: "w-50px" }
const _hoisted_91 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_92 = ["checked"]
const _hoisted_93 = { class: "min-w-150px text-uppercase" }
const _hoisted_94 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_95 = ["checked", "onClick"]
const _hoisted_96 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_97 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_98 = {
  key: 1,
  class: "accordion-item"
}
const _hoisted_99 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}
const _hoisted_100 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_2",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_2"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-4 text-primary" })
  ])
], -1))
const _hoisted_102 = {
  id: "kt_accordion_1_body_2",
  class: "accordion-collapse collapse accor-body",
  "aria-labelledby": "kt_accordion_1_header_2",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_103 = { class: "accordion-body" }
const _hoisted_104 = { class: "table-responsive" }
const _hoisted_105 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_106 = { class: "fw-bold text-muted" }
const _hoisted_107 = { class: "w-50px" }
const _hoisted_108 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_109 = ["checked"]
const _hoisted_110 = { class: "min-w-150px text-uppercase" }
const _hoisted_111 = { class: "min-w-150px text-uppercase" }
const _hoisted_112 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_113 = ["checked", "onClick"]
const _hoisted_114 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_115 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_116 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_117 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_118 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_119 = ["data-kt-indicator"]
const _hoisted_120 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_121 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_122 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_VZPhone = _resolveComponent("VZPhone")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_modal_new_target_user",
          onSubmit: _ctx.submitCloneData,
          ref: "cloneUserRef",
          class: "form",
          "validation-schema": _ctx.cloneUserData.validationSchema,
          "initial-values": _ctx.initialValues
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.clone")) + " - " + _toDisplayString(_ctx.userObj.firstName) + " " + _toDisplayString(_ctx.userObj.lastName), 1)
              ]),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"]))
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("tbody", _hoisted_11, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("common.firstName")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "firstName",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['firstName'],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cloneTargetData['firstName']) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ErrorMessage, { name: "firstName" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("common.lastName")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "lastName",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['lastName'],
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cloneTargetData['lastName']) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_ErrorMessage, { name: "lastName" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("common.email")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "email",
                          placeholder: "Email@example.com",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['email'],
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cloneTargetData['email']) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("pages.user.birthday")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "birthday",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps(field, {
                              modelValue: _ctx.cloneTargetData.birthday,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cloneTargetData.birthday) = $event)),
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              autoApply: true,
                              "model-type": "yyyy-MM-dd",
                              teleport: "body",
                              placeholder: _ctx.t('pages.user.birthday')
                            }), null, 16, ["modelValue", "format", "placeholder"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_ErrorMessage, { name: "birthday" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("common.password")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "password",
                          name: "password",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['password'],
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cloneTargetData['password']) = $event)),
                          class: "form-control"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_el_input, _mergeProps(field, {
                              modelValue: _ctx.cloneTargetData['password'],
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cloneTargetData['password']) = $event)),
                              "show-password": _ctx.passwordTrue,
                              onFocus: _ctx.clearPassword
                            }), null, 16, ["modelValue", "show-password", "onFocus"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.t("pages.user.confirmPassword")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "password",
                          name: "password_confirmation",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['password_confirmation'],
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cloneTargetData['password_confirmation']) = $event)),
                          class: "form-control"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_el_input, _mergeProps(field, {
                              modelValue: _ctx.cloneTargetData['password_confirmation'],
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cloneTargetData['password_confirmation']) = $event)),
                              onFocus: _ctx.clearConfirmPassword,
                              "show-password": _ctx.confirmPasswordTrue
                            }), null, 16, ["modelValue", "onFocus", "show-password"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("common.startDate")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "startDate",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps(field, {
                              modelValue: _ctx.cloneTargetData.startDate,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cloneTargetData.startDate) = $event)),
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              autoApply: true,
                              "model-type": "yyyy-MM-dd",
                              teleport: "body",
                              placeholder: _ctx.t('common.startDate'),
                              "min-date": _ctx.minDate
                            }), null, 16, ["modelValue", "format", "placeholder", "min-date"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_ErrorMessage, { name: "startDate" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t("common.endDate")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "endDate",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps({
                              modelValue: _ctx.cloneTargetData.endDate,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cloneTargetData.endDate) = $event))
                            }, field, {
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              autoApply: true,
                              "model-type": "yyyy-MM-dd",
                              placeholder: _ctx.t('common.endDate'),
                              teleport: "body",
                              "min-date": _ctx.minEndDate
                            }), null, 16, ["modelValue", "format", "placeholder", "min-date"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_ErrorMessage, { name: "endDate" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("common.phoneNumber")), 1)
                        ]),
                        _createVNode(_component_FieldArray, {
                          name: "phoneModel",
                          "key-path": "id"
                        }, {
                          default: _withCtx(({ fields, push, remove }) => [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: field.key
                                    }, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("div", _hoisted_59, [
                                          _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, [
                                              _createElementVNode("span", _hoisted_62, [
                                                _createElementVNode("div", _hoisted_63, [
                                                  _createVNode(_component_Field, {
                                                    id: `defaultPhone_${idx}`,
                                                    name: "defaultPhone",
                                                    value: field.key,
                                                    class: "form-check-input",
                                                    modelValue: _ctx.defaultPhoneIndex,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.defaultPhoneIndex) = $event)),
                                                    type: "radio"
                                                  }, null, 8, ["id", "value", "modelValue"])
                                                ])
                                              ]),
                                              _createVNode(_component_Field, {
                                                class: "form-control",
                                                name: `phoneModel[${idx}].phoneNumber`,
                                                type: "text",
                                                id: `phoneNumber_${idx}`
                                              }, {
                                                default: _withCtx(({ field }) => [
                                                  _createVNode(_component_VZPhone, _mergeProps(field, {
                                                    onEmitValidation: 
                                              (value) =>
                                                _ctx.handleValidation(value, idx)
                                            
                                                  }), null, 16, ["onEmitValidation"])
                                                ]),
                                                _: 2
                                              }, 1032, ["name", "id"]),
                                              _createElementVNode("span", _hoisted_64, [
                                                _createElementVNode("a", {
                                                  href: "javascript:;",
                                                  onClick: 
                                              () => {
                                                if (fields.length > 1) {
                                                  remove(idx);
                                                  const index =
                                                    fields.findIndex(
                                                      (item) =>
                                                        Number(item.key) ==
                                                        Number(item.key) + 1
                                                    );
                                                  if (index !== -1) {
                                                    _ctx.defaultPhoneIndex = Number(
                                                      Number(field.key) + 1
                                                    );
                                                  } else {
                                                    _ctx.defaultPhoneIndex = Number(
                                                      fields[0].key
                                                    );
                                                  }
                                                  _ctx.validationErrors.value.pop();
                                                }
                                              }
                                            
                                                }, _hoisted_67, 8, _hoisted_65)
                                              ])
                                            ]),
                                            (_ctx.validationErrors[idx])
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                  _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.t("common.invalidNumber")), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (
                                          !_ctx.validationErrors[
                                            fields.length - 1
                                          ] && idx == fields.length - 1
                                        )
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 1,
                                                  href: "javascript:;",
                                                  onClick: 
                                          () => {
                                            if (
                                              fields[fields.length - 1].value
                                                .phoneNumber != ''
                                            ) {
                                              push({
                                                id: null,
                                                type: 'CALL',
                                                phoneNumber: '',
                                                defaultPhone: false,
                                              });
                                            }
                                          }
                                        
                                                }, _hoisted_73, 8, _hoisted_70))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_ErrorMessage, { name: `defaultPhone` })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          (_ctx.cloneUserData?.sites?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                _createElementVNode("h2", _hoisted_79, [
                                  _createElementVNode("button", _hoisted_80, [
                                    _hoisted_81,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.sites")) + " ", 1),
                                    (_ctx.siteValidation)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.t("validation.siteValidation")), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_85, [
                                  _createElementVNode("div", _hoisted_86, [
                                    _createElementVNode("div", _hoisted_87, [
                                      _createElementVNode("table", _hoisted_88, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_89, [
                                            _createElementVNode("th", _hoisted_90, [
                                              _createElementVNode("div", _hoisted_91, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  value: "",
                                                  checked: 
                                              _ctx.cloneTargetData?.sites?.length >
                                                0 &&
                                              _ctx.cloneTargetData?.sites?.length ==
                                                _ctx.cloneUserData?.sites?.length
                                            ,
                                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectAll($event, 'sites')))
                                                }, null, 8, _hoisted_92)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.t("common.siteName")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneUserData.sites, (site, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_94, [
                                                  _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "form-check-input",
                                                    value: "",
                                                    checked: 
                                                _ctx.isChecked('sites', site.webId)
                                              ,
                                                    onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  site.webId,
                                                  'sites'
                                                )
                                              )
                                                  }, null, 8, _hoisted_95)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_96, [
                                                  _createElementVNode("span", _hoisted_97, _toDisplayString(site.siteName), 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.cloneUserData?.forms?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                _createElementVNode("h2", _hoisted_99, [
                                  _createElementVNode("button", _hoisted_100, [
                                    _hoisted_101,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.forms")), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("div", _hoisted_103, [
                                    _createElementVNode("div", _hoisted_104, [
                                      _createElementVNode("table", _hoisted_105, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_106, [
                                            _createElementVNode("th", _hoisted_107, [
                                              _createElementVNode("div", _hoisted_108, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  value: "",
                                                  checked: 
                                              _ctx.cloneTargetData?.forms?.length >
                                                0 &&
                                              _ctx.cloneTargetData?.forms?.length ==
                                                _ctx.cloneUserData?.forms?.length
                                            ,
                                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectAll($event, 'forms')))
                                                }, null, 8, _hoisted_109)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_110, _toDisplayString(_ctx.t("common.formName")), 1),
                                            _createElementVNode("th", _hoisted_111, _toDisplayString(_ctx.t("common.siteName")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneUserData.forms, (form, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_112, [
                                                  _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "form-check-input",
                                                    value: "",
                                                    checked: 
                                                _ctx.isChecked('forms', form.siteId)
                                              ,
                                                    onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  form.siteId,
                                                  'forms'
                                                )
                                              )
                                                  }, null, 8, _hoisted_113)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_114, [
                                                  _createElementVNode("span", _hoisted_115, _toDisplayString(form.name), 1)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_116, [
                                                  _createElementVNode("span", _hoisted_117, _toDisplayString(form.siteName), 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("button", {
                type: "reset",
                id: "form_clone_cancel",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)))
              }, _toDisplayString(_ctx.t("common.close")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.save")), 1),
                      _createElementVNode("span", _hoisted_121, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_122, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_123
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_119)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ])
    ])
  ], 512))
}